import { render, staticRenderFns } from "./AddSeverance.vue?vue&type=template&id=604c5644&scoped=true&"
import script from "./AddSeverance.vue?vue&type=script&lang=js&"
export * from "./AddSeverance.vue?vue&type=script&lang=js&"
import style0 from "./AddSeverance.vue?vue&type=style&index=0&id=604c5644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c5644",
  null
  
)

export default component.exports